<template>
  <div>
    <button @click.prevent="onSubmit" :disabled="submited" class="btn"> Relatório </button>
    <Loading></Loading>
  </div>
</template>

<script>
import Loading from "../monitoramentos/Loading";
export default {
  name: "BotaoEnviarRelatorioConsumo",
  components: {
    Loading
  },
  props: {
    fatura: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submited: false
    };
  },
  methods: {
    onSubmit: function() {
      EventBus.$emit('loading-show');

      this.submited = true;
      axios({
        method: "post",
        url: "faturas/relatorio-consumo/" + this.fatura.id,
      })
        .then(response => {
          EventBus.$emit("loading-hide");

          this.$store.dispatch("showLoadingMessage", {
            message: "O relatório foi enviado para seu email!",
            type: "done"
          });
        })
        .catch((error) => {
          EventBus.$emit('loading-hide');

          this.submited = false;
          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
  }
}

</script>

<style scoped>

</style>
